import { filter } from 'rxjs/operators';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { Options } from '@angular-slider/ngx-slider';
import { AppService } from '../app.service';
import { BogTourService } from './../services/bog-tour/bog-tour.service';

// [formControl]="formControl" [formlyAttributes]="field"
@Component({
  selector: 'vpc-haz-risk-level',
  styles: [
    `
      .slider_height {
        height: 24px;
      }
      .rang_slider_row {
        background: transparent
          linear-gradient(
            90deg,
            #f00014 0%,
            #f00214 20%,
            #ffd200 36%,
            #ffd200 57%,
            #94c12e 82%,
            #009146 100%
          )
          0% 0% no-repeat padding-box;
        border-radius: 12px;
        opacity: 1;
        @extend .slider_height;
      }
      .rang_slider_col {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Nunito';
        color: #000;
        font-size: 10px;
      }
      .diamond {
        width: 13px;
        height: 13px;
        transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
        background: #2f2f2f 0% 0% no-repeat padding-box;
        border-radius: 2px;
        opacity: 1;
      }
      .black_div {
        font-size: 12px;
        font-weight: bold;
        margin-left: -15px;
        color: #000;
        margin-top: 3px;
      }
      .bog_logo_circle {
        width: 40px;
        height: 40px;
        background: var(---ffffff) 0% 0% no-repeat padding-box;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000029;
        border: 2px solid #1d446f;
        opacity: 1;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .slider_bog_logo {
        height: 25px;
      }
      .selected_risk_icon_div {
        width: 54px;
        height: 48px;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 4px;
        opacity: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        margin-top: -5px;
      }
      .unselected_risk_icon_div {
        width: 32px;
        height: 29px;
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        opacity: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }
      .alertIcon {
        position: absolute;
        color: #000;
        font-size: 12px;
        margin-top: 2px;
      }
      .unselected_risk_icon_div img {
        display: block;
      }
      unselected_risk_icon_div .risk_range {
        color: #000;
        font-size: 12px;
        letter-spacing: 0.32px;
        text-align: center;
      }
      .risk_range_row {
        margin-top: 7px;
      }
      .risk_hint_row {
        margin-top: 10px;
      }
      .HSE_feed_div {
        background: #f7f7f7 0% 0% no-repeat padding-box;
        text-align: left;
        font-size: 14px;
        letter-spacing: 0.47px;
        color: #000000;
        opacity: 1;
        display: flex;
        justify-content: end;
        align-items: center;
        height: 30px;
        margin-top: 10px;
      }
      .HSE_toggle_btn {
        margin: 0 10px;
      }
      .alert_selected {
        position: absolute;
        color: #000;
        font-size: 23px;
        margin-top: 5px;
      }
      .bravo_good_practice_container {
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 100%;
      }
      .bravo_section {
        background: transparent;
        border-radius: 8px;
        padding: 15px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: #009146;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid #E0E0E0;
        min-height: 80px;
        width: 100%;
      }
      .bravo_section.selected {
        background: #EDF5F5;
        border: 1px solid #009146;
        box-shadow: none;
      }
      .bravo_section.unselected {
        background: transparent;
        border: 1px solid #E0E0E0;
        box-shadow: none;
      }
      .good_practice_section {
        background: transparent;
        border-radius: 8px;
        padding: 15px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: #F00014;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid #E0E0E0;
        min-height: 80px;
        width: 100%;
      }
      .good_practice_section.selected {
        background: #EDF5F5;
        border: 1px solid #007382;
        box-shadow: none;
      }
      .good_practice_section.unselected {
        background: transparent;
        border: 1px solid #E0E0E0;
        box-shadow: none;
      }
      .kudos_section {
        background: #FFFFF2;
        border-radius: 8px;
        padding: 15px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: #70870A;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid #85A00E;
        min-height: 80px;
        width: 100%;
      }
      .medium_risk_section {
        background: #FFF3E6;
        border-radius: 8px;
        padding: 15px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: #DD7601;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid #DD7601;
        min-height: 80px;
        width: 100%;
      }
      .minor_risk_section {
        background: #FFFBE8;
        border-radius: 8px;
        padding: 15px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: #AE8800;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid #CCA105;
        min-height: 80px;
        width: 100%;
      }
      .section_icon {
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
      }
      .section_content {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.4;
      }
      .section_title {
        font-weight: 700;
        margin-bottom: 4px;
        display: grid;
        grid-template-columns: auto 1fr;
        grid-template-rows: auto auto;
        gap: 4px 8px;
      }
      .title_row {
        display: flex;
        align-items: center;
        grid-column: 1 / -1;
      }
      .inline_icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
      .section_desc {
        color: #000000;
        font-weight: 500;
        font-size: 14px;
        /* margin-top: 2px; */
        grid-column: 2;
        text-align: left;
        margin-left: 20px;
      }
      .section_title.bravo_color {
        color: inherit;
      }
      .section_title.kudos_color {
        color: #70870A;
      }
      .section_title.good_practice_color {
        color: #007382;
      }
      .section_title.medium_risk_color {
        color: #DD7601;
      }
      .section_title.minor_risk_color {
        color: #AE8800;
      }
      .bravo_select {
        background: #007382;
        height: 50px;
        width: 140px;
        padding-top: 8px;
        padding-left: 20px;
        border: 1px solid #007382;
        border-radius: 4px;
        color: #ffffff;
        font-size: 14px;
      }
      .bravo_unselect {
        border: 1px solid #007382;
        height: 50px;
        width: 140px;
        padding-top: 8px;
        padding-left: 20px;
        background: white;
        border-radius: 4px;
        font-size: 14px;
      }
      .HSE_bravo_div {
        background: #f7f7f7 0% 0% no-repeat padding-box;
        text-align: left;
        font-size: 14px;
        letter-spacing: 0.47px;
        color: #000000;
        opacity: 1;
        align-items: center;
        margin-top: 10px;
        height: 80px;
        display: flex;
        justify-content: space-between;
        padding: 0 10px 0 10px;
      }
      
      .slider-custom-tooltip {
        display: none;
      }
      .down_arrow {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #ffffff;
        position: absolute;
        bottom: -5px;
      }
      .big-card-qrrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #ffffff;
        position: absolute;
        top: 46px;
      }
      .separator-line-col {
        display: flex;
        justify-content: space-around;
        margin-bottom: -42px;
        z-index: 999;
        height: 45px;
        pointer-events: none;
      }
      .separator-line {
        border-right: 1px dotted grey;
        height: 40px;
      }
      .disableCard {
        pointer-events: none;
        opacity: 0.6;
      }
    `,
  ],
  template: `
    <div
      *ngIf="to.myoptions && to.source == 'VPC_ADD'">
      <ion-row>
        <ion-col class="rang_slider_col" *ngFor="let risk_ of to.myoptions">
          <div *ngIf="value == risk_.value" class="selected_risk_icon_div">
            <img src="assets/img/bog_tour/rang_slider/{{ risk_.highlightIcon }}" />
            <ion-icon
              *ngIf="risk_.level == 'minor_risk'"
              name="alert-outline"
              role="img"
              class="alert_selected"
            ></ion-icon>
            <div class="big-card-qrrow-down"></div>
          </div>
          <div *ngIf="value != risk_.value" class="unselected_risk_icon_div">
            <img src="assets/img/bog_tour/rang_slider/{{ risk_.icon }}" />
            <ion-icon
              *ngIf="risk_.level == 'minor_risk'"
              name="alert-outline"
              role="img"
              class="alertIcon"
            ></ion-icon>
            <div class="down_arrow"></div>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-align-self-center ion-text-left separator-line-col">
          <div class="separator-line"></div>
          <div class="separator-line"></div>
        </ion-col>
      </ion-row>
      <ion-row style="margin-top:-25px;">
        <ngx-slider
          [(value)]="value"
          [options]="slider_options"
          (valueChange)="onSliderChange($event)"
        ></ngx-slider>
        <div class="slider-custom-tooltip"></div>
      </ion-row>
      <ion-row class="risk_range_row">
        <ion-col class="rang_slider_col risk_range" *ngFor="let item of risk_slider">
          {{ item.risk_range |translate }}
        </ion-col>
      </ion-row>
      <ion-row *ngIf="selected_risk?.level!='immediate_risk'" class="risk_hint_row">
        <ion-col>
          <div
            *ngIf="selected_risk?.HSE_enable && selected_risk?.level == 'bravo'"
            class="HSE_feed_div"
          >
            {{ 'SHIELD_POST_IT_TO_HSE_FEED' | translate }}
            <div class="HSE_toggle_btn">
              <ion-toggle [checked]="selected_risk?.HSE_feed" (ionChange)="myChange()">
              </ion-toggle>
            </div>
          </div>
          <div *ngIf="selected_risk?.level == 'bravo'" class="bravo_good_practice_container">
            <div 
              class="bravo_section"
              [ngClass]="{'selected': selectedCardType === 'bravo', 'unselected': selectedCardType !== 'bravo'}"
              (click)="selectCardType('bravo')"
            >
              <div class="section_content">
                <div class="section_title bravo_color">
                  <div class="title_row">
                    <img src="assets/img/bog_tour/rang_slider/risk_bravo_big.svg" alt="Bravo Icon" class="inline_icon">
                      {{'SHIELD.OBSERVATION_BRAVO'|translate}}
                  </div>
                  <div class="section_desc"> {{'SHIELD.OBSERVATION_BRAVO_CARD_CONTENT'|translate}}</div>
                </div>
              </div>
            </div>
            <div 
              class="good_practice_section"
              [ngClass]="{'selected': selectedCardType === 'good_practice', 'unselected': selectedCardType !== 'good_practice'}"
              (click)="selectCardType('good_practice')"
            >
              <div class="section_content">
                <div class="section_title good_practice_color">
                  <div class="title_row">
                    <img src="assets/img/bog_tour/rang_slider/good.svg" alt="Good Practice Icon" class="inline_icon">
                    {{'SHIELD.OBSERVATION_GOOD_PRACTICE'|translate}}
                  </div>
                  <div class="section_desc"> {{'SHIELD.OBSERVATION_GOOD_PRACTICE_CARD_CONTENT'|translate}}</div>
                </div>
              </div>
            </div>
            
            
          </div>
          <div *ngIf="selected_risk?.level == 'kudos'" class="bravo_good_practice_container">
            <div class="kudos_section">
              <div class="section_content">
                <div class="section_title kudos_color">
                  <div class="title_row">
                    <img src="assets/img/bog_tour/rang_slider/risk_kudos_big.svg" alt="Kudos Icon" class="inline_icon">
                     {{'CHECK_IN.KUDOS'|translate}}
                  </div>
                  <div class="section_desc"> {{'SHIELD.OBSERVATION_KUDOS_CARD_CONTENT'|translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="selected_risk?.level == 'medium_risk'" class="bravo_good_practice_container">
            <div class="medium_risk_section">
              <div class="section_content">
                <div class="section_title medium_risk_color">
                  <div class="title_row">
                    <img src="assets/img/bog_tour/rang_slider/risk_medium_big.svg" alt="Medium Risk Icon" class="inline_icon">
                    {{'SHIELD.OBSERVATION_MEDIUM_RISK'|translate}}
                  </div>
                  <div class="section_desc"> {{'SHIELD.OBSERVATION_MEDIUM_RISK_CARD_CONTENT'|translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="selected_risk?.level == 'minor_risk'" class="bravo_good_practice_container">
            <div class="minor_risk_section">
              <div class="section_content">
                <div class="section_title minor_risk_color">
                  <div class="title_row">
                    <img src="assets/img/bog_tour/rang_slider/risk_minor_big.svg" alt="Minor Risk Icon" class="inline_icon">
                    {{'SHIELD.OBSERVATION_MINOR_RISK'|translate}}
                  </div>
                  <div class="section_desc"> {{'SHIELD.OBSERVATION_MINOR_RISK_CARD_CONTENT'|translate}}</div>
                </div>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
  `,
  standalone: false,
})
export class vpcHazRiskSliderFormlyType extends FieldType{
  editFlag: 'edit' | '' = '';
  selected_risk: any;
  risk_slider: any = [];
  // signalValue$:any;
  checkBox: any;
  value: number = 3;
  selectedCardType: string = 'bravo'; // Default to BRAVO selection
  slider_options: Options = {
    showTicksValues: true,
    stepsArray: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }],
  };
  constructor(
    private appService: AppService,
    private bogService: BogTourService,
    private lhStorage: LhStorageService
  ) {
    super();
    // this.signalValue$ = this.appService;
    // let subscribtion=this.appService.riskLevelSubject.subscribe((res:any)=>{
    //   console.log("ttt",(typeof res))
    //   if(this.to.myoptions!=undefined && res!=''){
    //     this.risk_slider=this.to.myoptions;
    //     let item= this.risk_slider.filter((obj:any)=> obj.level==res)
    //     this.riskLevelClick(item)
    //      console.log("testing data",res,this.to.myoptions)

    //   }
    // })
    // this.bogService.obs_subscriptions.add(subscribtion)
  }
  myChange() {
    this.selected_risk.HSE_feed = !this.selected_risk.HSE_feed;
    this.applyValue();
  }

  selectCardType(cardType: string) {
    this.selectedCardType = cardType;
    // Reset checkBox when switching card types
    this.checkBox = null;

    // Emit the selection to parent component
    this.appService.bravoGoodPracticeCheckBox.next({
      name: 'bravo',
      type: cardType === 'bravo' ? 'nominate' : 'good_practice'
    });
  }

  recordGoodPractice() {
    // Handle recording good practice
    console.log('Recording good practice...');
    // Add your good practice recording logic here
  }

  shareToSocialFeed() {
    // Handle sharing to social feed
    console.log('Sharing to social feed...');
    // Add your social feed sharing logic here
  }
  applyValue() {
    let obj = {
      risk_level: this.selected_risk.level,
      HSE_feed: this.selected_risk.HSE_feed,
      HSE_enable: this.selected_risk.HSE_enable,
      nominate_flag: false,
      gp_flag: false,
    };
    if (this.selected_risk.level == 'kudos') {
      obj.nominate_flag = true;
      obj.gp_flag = false;
    } else if (this.selected_risk.level == 'bravo' && this.checkBox == 'nominate') {
      obj.nominate_flag = true;
      obj.gp_flag = false;
    } else if (this.selected_risk.level == 'bravo' && this.checkBox == 'good_practice') {
      obj.gp_flag = true;
      obj.nominate_flag = false;
    }
    this.formControl.patchValue(obj);
    this.formControl.markAsTouched();
    //making false not part of 3.5
    obj.HSE_enable = false;
    obj.HSE_feed = false;
    //
    this.appService.updateriskLevelSubject(obj.risk_level);
    this.selected_risk.HSE_enable = false;
    let risklevel_Obj = { name: this.selected_risk.level, type: this.checkBox };
    this.appService.updatebravoGoodPracticeCheckBox(risklevel_Obj);
  }

  async ngOnInit() {
    //
    this.risk_slider = this.to.myoptions;
    // this.applyValue();
    this.checkBox = "nominate";
    this.selectedCardType = "bravo"; // Set BRAVO as default selection
    // this.appService.updatebravoGoodPracticeCheckBox(this.checkBox);
    this.editFlag = '';
    let editObservation = await this.lhStorage.get('editObservation');
    if (editObservation != null) {
      this.editFlag = 'edit';
      let data: any = editObservation.currentObservationInfo;
      this.to.myoptions.forEach((element) => {
        if (element.level == data.risk_level.risk_level) {
          element.selected = true;
          element.HSE_feed = false;
          element.HSE_enable = false;
          this.selected_risk = element;
        } else {
          element.selected = false;
        }
      });

      if (data?.risk_level?.risk_level == 'kudos') {
        this.selected_risk.level = 'kudos';
        this.checkBox = 'nominate';
      } else if (data?.risk_level?.risk_level == 'bravo' && data?.risk_level.nominate_flag) {
        this.selected_risk.level = 'bravo';
        this.checkBox = 'nominate';
      } else if (data?.risk_level?.risk_level == 'bravo' && data?.risk_level.gp_flag) {
        this.selected_risk.level = 'bravo';
        this.checkBox = 'good_practice';
      }
      this.value = this.selected_risk.value;
    } else {
      this.selected_risk = this.risk_slider[2];
    }
    this.applyValue();
  }
  riskLevelClick(item) {
    console.log('riskLevelClick:', item);
    this.selected_risk = item;
    this.risk_slider.forEach((element) => {
      element.selected = false;
      if (element.level == item.level) {
        element.selected = true;
      }
    });

    // Set default BRAVO selection when BRAVO is selected
    if (item.level === 'bravo') {
      this.selectedCardType = 'bravo';
      this.checkBox = 'nominate'; // Default to nominate
    } else {
      // Reset card selection for other risk levels
      this.selectedCardType = 'bravo';
      this.checkBox = 'nominate';
    }

    this.applyValue();
    // if(item.level=='bravo'){
    // let obj={name:item.level,type:this.checkBox};
    // this.appService.updatebravoGoodPracticeCheckBox(obj);
    // }
  }
  selectType(type) {
    this.checkBox = type;
    let obj = { name: 'bravo', type: this.checkBox };
    this.applyValue();
    this.appService.updatebravoGoodPracticeCheckBox(obj);
  }
  get tooltipContent(): any {
    if (this.value == 1) {
      let item: any;
      this.risk_slider.forEach((element) => {
        if (element.value == this.value) {
          item = element;
        }
      });
      this.riskLevelClick(item);
    }
    return this.value;
  }
  onSliderChange(event: any) {
    console.log('onSliderChange event:', event);
    let item: any;
    this.risk_slider.forEach((element) => {
      if (element.value == this.value) {
        item = element;
      }
    });
    this.riskLevelClick(item);
  }
}
